import { render, staticRenderFns } from "./MaterialSimulation.vue?vue&type=template&id=06d5cc32"
import script from "./MaterialSimulation.vue?vue&type=script&lang=js"
export * from "./MaterialSimulation.vue?vue&type=script&lang=js"
import style0 from "./MaterialSimulation.vue?vue&type=style&index=0&id=06d5cc32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports